/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum edsn_CSPproduct {
    CAPACITEITSBEPERKING = 'Capaciteitsbeperking',
    REDISPATCH = 'Redispatch',
}
